import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { JenisTag, NewReplyBadge } from "@/components/admin/JenisTag";
import { MediaThumbs } from "@/components/admin/MediaThumbs";
import { StatusSelect } from "@/components/admin/StatusSelect";
import { formatDateID, formatPhone } from "@/lib/format";

const HEADERS = ["No. Tiket", "Nama", "Alamat", "Tanggal", "Jenis", "Detail", "Media", "Status"];

export const ComplaintsTable = ({ complaints, onStatusChange, updatingId, onOpenMedia, onOpenDetail }) => (
  <div className="overflow-x-auto">
    <Table data-testid="complaints-table">
      <TableHeader>
        <TableRow className="bg-slate-50 hover:bg-slate-50">
          {HEADERS.map((h) => (
            <TableHead key={h} className="whitespace-nowrap text-xs font-semibold uppercase tracking-wider text-slate-500">{h}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {complaints.map((c) => (
          <TableRow key={c.id} className="align-top transition-colors hover:bg-emerald-50/30" data-testid={`complaint-row-${c.id}`}>
            <TableCell className="whitespace-nowrap font-mono text-xs font-semibold text-slate-700" data-testid={`complaint-ticket-${c.id}`}>#{c.ticket}</TableCell>
            <TableCell className="min-w-[150px]">
              <p className="font-semibold text-slate-900">{c.nama}</p>
              {c.nomor_hp && <p className="text-xs text-slate-500" data-testid={`complaint-phone-${c.id}`}>{formatPhone(c.nomor_hp)}</p>}
            </TableCell>
            <TableCell className="min-w-[160px] text-slate-600">{c.alamat}</TableCell>
            <TableCell className="whitespace-nowrap text-slate-600">{formatDateID(c.tanggal)}</TableCell>
            <TableCell className="min-w-[180px]"><JenisTag jenis={c.jenis} /></TableCell>
            <TableCell className="min-w-[220px] max-w-[300px]">
              <p className="line-clamp-2 text-sm text-slate-600">{c.detail}</p>
              <button type="button" onClick={() => onOpenDetail(c)} className="mt-1 text-xs font-semibold text-emerald-700 hover:underline" data-testid={`detail-btn-${c.id}`}>
                Lihat detail
              </button>
              {c.has_new_reply && <NewReplyBadge id={c.id} />}
            </TableCell>
            <TableCell><MediaThumbs attachments={c.attachments} onOpen={onOpenMedia} ownerId={c.id} /></TableCell>
            <TableCell><StatusSelect complaint={c} onChange={onStatusChange} disabled={updatingId === c.id} /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
